<template>
  <div class="tag">
    <div class="name">
      <slot />
    </div>
    <div class="num">
      {{ num }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'rw-tag',
  props: {
    num: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped lang="scss">
.tag {
  min-width: 70px;
  display: inline-flex;
  align-items: center;
  padding: 3px 4px 3px 10px;
  justify-content: space-between;
  border-radius: 12px;
  border: 1px solid #dbe4f1;
  background-color: #ebf0f6;
  color: #6e7c91;
  font-size: 12px;
  font-weight: 500;

  .name {
    margin-right: 6px;
  }

  .num {
    height: 17px;
    line-height: 17px;
    font-weight: 700;
    padding: 0 6px;
    border-radius: 8px;
    background-color: #fff;
  }
}
</style>
